import axios from 'axios'
import AuthService from '@/services/AuthService'
import {
  LOG_OUT,
  SET_USER,
  TOGGLE_AUTH_MODAL,
} from '@/store/modules/auth/mutations-types'

export default {
  async getAuthUser ({ commit, }) {
    try {
      const response = await AuthService.getAuthUser()

      commit(SET_USER, {
        email: response.data.email,
        name: response.data.name,
      })
      commit(TOGGLE_AUTH_MODAL, false)
    } catch (error) {
      commit(SET_USER, {
        email: null,
        user: null,
      })

      throw error
    }
  },
  async logOut ({ commit, }) {
    return AuthService.logout()
      .then(() => {
        commit(LOG_OUT)
      })
      .catch((e) => console.error(e))
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js